import Head from 'next/head'

type SchemaMarkupProps = {
  schema: object | object[]
  id: string
}

const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ schema, id }) => {
  const schemas = Array.isArray(schema) ? schema : [schema]

  return (
    <Head>
      {schemas.map((s, index) => (
        <script
          key={index === 0 ? id : `${id}-${index}`}
          id={index === 0 ? id : `${id}-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(s)
              .replace(/</g, '\\u003c')
              .replace(/>/g, '\\u003e')
              .replace(/&/g, '\\u0026')
              .replace(/\u2028/g, '\\u2028')
              .replace(/\u2029/g, '\\u2029'),
          }}
        />
      ))}
    </Head>
  )
}

export default SchemaMarkup
